import Invoice from '~/app/invoicing/models/Invoice';

const useSendPaymentReminderModal = () => {
    const openModal = (invoice?: Invoice) => {
        const eventName = invoice?.contact ? 'invoicing:invoice:send-payment-reminder:open' : 'invoicing:invoice:select-contact:open';
        useEvent(eventName, { invoice });
    };

    return {
        openModal,
    };
};

export default useSendPaymentReminderModal;
